import React, { useEffect , useCallback , useState } from 'react';
import { useParams } from "react-router-dom";

import { useGlobalContext } from '../../context/GlobalContext';

import { useForm } from "react-hook-form";
import { API_URL } from '../../../actions';
import { clearMarkup } from '../../../utils/utils';
import SelectMedia from '../medias/SelectMedia'; 

import { getMediasAction } from '../../../actions/mediasActions';
import { getCompanyAction } from '../../../actions/companiesActions';
import { getPageAction , updatePageAction } from '../../../actions/themeActions';

import BlocText from '../../partials/BlocText';
import EditKeysFigures from '../../partials/EditKeysFigures';
import PromptRouter from '../../partials/PromptRouter';
import RemoveModale from '../../partials/RemoveModale/RemoveModale';
// import TextEditor from '../../partials/TextEditor';

import '../../../styles/pages-sites.scss';
import MetaSeo from '../../partials/MetaSeo';

export default function Approach({ setDisplayNavBar, setDisplaySelectLang , setDisplaySiteNav ,  setActivePage , theme , lang }) {

  const param = useParams();

  const page = 'approach';

  const { handleSubmit, register, errors } = useForm();

  const [ context, dispatch ] = useGlobalContext();

  const [ approach, setApproach ] = useState();

  const [ isMounted , setIsMounted ] = useState(false);
  const [ isSaved , setIsSaved ] = useState(true);
  const [ removeAction , setRemoveAction ] = useState();

  const [ displaySelectMedia , setDisplaySelectMedia ] = useState(false);
  const [ selectedMediaList , setSelectedMediaList ] = useState([]);
  const [ mediaIsMulti , setMediaIsMulti ] = useState(false);
  const [ mediaType , setMediaType ] = useState();
  const [ mediaKey , setMediaKey ] = useState('picture');
  const [ publishIsLoading , setPublishIsLoading ] = useState(false);

  const getCompany = useCallback(() => {
    getCompanyAction(dispatch , param.companyId );
    getMediasAction(dispatch, param.companyId);
  },[dispatch , param.companyId ]);

  useEffect(() => {
    setDisplayNavBar(true);
    setDisplaySelectLang(true);
    setDisplaySiteNav(true)
    setActivePage("approach");
    getCompany();
    return () => {
      setDisplaySelectLang(false);
      setApproach();
      setIsMounted(false);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getPageAction(dispatch , param.companyId , page , lang );
    setApproach();
    setIsMounted(false)
    dispatch({
      type:'RESET_PAGE',
    });
    // eslint-disable-next-line
  },[lang]);

  useEffect(() => {
    if (context.theme.page) {
      setApproach({...context.theme.page });
      setIsMounted(true)
    } else {
      setApproach();
      setIsMounted(false)
    };

    dispatch({
      type:'MESSAGE_PAGE',
      payload: null
    });
    // eslint-disable-next-line
  }, [context.theme.page]);

    useEffect(() => {
      if (approach && context.theme.page) {
        if (JSON.stringify(approach) === JSON.stringify(context.theme.page)) {
          setIsSaved(true);
        } else {
          setIsSaved(false);
        }
      }
    // eslint-disable-next-line
  },[approach])

  useEffect(() => {
    if (context.theme && context.theme.message === 'Theme successfully updated' ) {
      setPublishIsLoading(false);

      dispatch({
        type:'MESSAGE_PAGE',
        payload: null
      });

      dispatch({
        type: 'SET_TOAST',
        payload: {
          message: "La page a bien été enregistré",
          type: "success"
        }
      });

    };

    // eslint-disable-next-line
  },[context.theme.message]);



  function submitMedia(value) {
    switch (mediaKey) {
      
      case "picture":
        setApproach({...approach, picture: value[0]})
        break;
    
      default:
        break;
    }
  };

  function handleChangeBloc(val , i) {
    var blocs = [...approach.blocs];
    blocs[i] = val;
    setApproach({...approach, blocs: blocs })
  }

  function addBloc() {
    var addBlocs = [...approach.blocs];
    addBlocs.push({ title: "" , text: "" });
    setApproach({...approach, blocs: addBlocs })
  }

  function deleteBloc(bloc) {
    var deleteBloc = [...approach.blocs];
    setApproach({...approach, blocs: deleteBloc.filter(item => item !== bloc)})
  }

  function openSelectCover() {
    setDisplaySelectMedia(true);
    setMediaIsMulti(false);
    setMediaKey('picture');
    setMediaType('image');
    if (approach&& approach.picture) {
      var pictureArray = [];
      pictureArray.push(approach.picture);
      setSelectedMediaList(pictureArray)
    }
  }

  const submitapproach= (values)  => {
    var approachData = {...values, ...approach};
    var obj = {};
    setPublishIsLoading(true);
    
    for (const [key, value] of Object.entries(approachData)) {
        obj[`${page}.${key}`] = value;
    }

    if (param.companyId === "5e9ec41b25ab1e65768e2ff0") {
      updatePageAction(dispatch , context.companies.company.theme[lang] , 'group' , page , obj  );
    } else {
      updatePageAction(dispatch , context.companies.company.theme[lang] , 'subsidiary' , page , obj  );
    }

    dispatch({
      type:'ERROR_PAGE',
      payload: null
    });
    dispatch({
      type:'MESSAGE_PAGE',
      payload: null
    });
  };

  function renderCoverImg() {
    var imgFound;
    if(approach&& approach.picture && context.medias.mediasList) {
      imgFound = context.medias.mediasList.find(item => item._id === approach.picture )
      if (imgFound) {
        return <img src={API_URL + '/' + imgFound.path} alt="approach" />
      } else if (approach.picture && approach.picture.path) {
        return <img src={API_URL + '/' + approach.picture.path} alt="approach" />
      }
    }
  }

  function renderEdit() {
    return (
      <div className="list-item transition edit-row">
        <form onSubmit={handleSubmit(submitapproach)} autoComplete="nope">
      
            <div className="form-row">
              <div className="col-1">
                
                <div className="title">
                  <h1 dangerouslySetInnerHTML={{ __html: approach && approach.title ? clearMarkup(approach.title) : "" }} ></h1>
                </div>

                <label htmlFor="title">Titre de la page</label>
                <input
                  name="title"
                  onChange={(e) => setApproach({...approach, title: e.target.value})}
                  defaultValue={approach&& approach && approach.title ? approach.title  : undefined }
                  ref={register({
                    required: "Compléter le titre",
                  })}
                />
                <p className="error">{errors && errors.title && errors.title.message}</p>

                <div>
                  <input id="isWhite"
                    onChange={() => setApproach({...approach, titleIsWhite: !approach.titleIsWhite })}
                    type="checkbox" className="switch" checked={!approach.titleIsWhite}
                    />
                  <label htmlFor="isWhite">{approach.titleIsWhite ? <span>Titre en blanc</span> : <span>Titre en noir</span> }</label>
                </div>

                <div className="section"></div>

                <div className="title">
                  <h2>Les paragraphes</h2>
                </div>

                {approach && approach.blocs && approach.blocs.map((bloc , i ) => (<BlocText
                  key={'blocktext' + i }
                  setBlockText={(val) => handleChangeBloc(val , i)}
                  deleteBloc={(val) => setRemoveAction({ function: () => deleteBloc(val)})}
                  nbBlocs={approach.blocs.length}
                  blockText={bloc}
                  index={i} />
                ))}

                <div className="btn-container" >
                  <button
                    className={`btn primary ${theme}-bg`}
                    style={{ marginBottom: 40}}
                    onClick={() => addBloc() }
                    type="button"
                    >
                    Ajouter un paragraphe
                  </button>
                </div>

                <div className="section"></div>

                <div className="title">
                  <h2>Chiffres clés</h2>
                </div>

                <EditKeysFigures keyFigures={approach.keyFigures} setRemoveAction={setRemoveAction} handleChange={ keyList => setApproach({...approach, keyFigures: keyList })} theme={theme}/>

              </div>

              <div className="col-2">
                <div className="btn-actions-container" >
                  {publishIsLoading ?
                    null
                    :
                    <button
                      className={`btn primary publish ${theme}-bg`}
                      type="submit"
                      >
                      Publier
                    </button>
                  }
                </div>

                <label>Photo de couverture<span className={`${theme}-color required`}>*</span><br/><span className="note">minimum 1700 x 350 px</span></label>
                {renderCoverImg()}
                <div className="btn-container">
                  
                  <button
                    type="button"
                    className={`btn primary ${theme}-bg`}
                    onClick={() => openSelectCover(true)}
                    >
                    Parcourir
                  </button>

                  {approach && approach.picture &&
                    <button
                      type="button" 
                      className={`btn primary ${theme}-bg`}
                      onClick={() => setRemoveAction({ function:() => setApproach({...approach, picture: null })})}
                      >
                      Supprimer
                    </button>
                  }
                </div>

              </div>
            </div>

            <MetaSeo
              seo={approach?.seo}
              onChange={(seoData) => setApproach({ ...approach, seo: seoData })}
              theme={theme}
              companyId={param.companyId}
            />
            
        </form>
        <SelectMedia
          displaySelectMedia={displaySelectMedia}
          dispatch={dispatch}
          theme={theme}
          context={context}
          mediaType={mediaType}
          selectedMediaList={selectedMediaList}
          companyId={param.companyId}
          isMulti={mediaIsMulti}
          handleChange={(value) => submitMedia(value)}
          setDisplaySelectMedia={setDisplaySelectMedia}
        />
      </div>
    )
  }

  return (
    <>
      <PromptRouter when={!isSaved} />     
      {isMounted && approach && <div id="approach" className={`page-container site ${theme}`}>
        <div className="page-content">

          <div className="title-row space-between">

            <div className="flex">

              <div className="title">
                <h1>Edition de la page approche globale({lang})</h1>
                <div className="bar primary"></div>
              </div>

            </div>

          </div>

          <div className="list-container">
            {renderEdit()}
          </div>

        </div>
      </div>}
      <RemoveModale removeAction={removeAction} setRemoveAction={setRemoveAction} theme={theme}/> 
    </>

  )
}
